import { Directive, effect, inject, input } from "@angular/core";

import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { Options } from "@popperjs/core";

@Directive({
  selector: "[directivePopoverConfig]"
})
export class PopoverConfigDirective {
  private readonly _popover = inject(NgbPopover, { self: true });

  readonly directivePopoverConfig = input<Partial<Options> | null | "">(null);

  constructor() {
    effect(() => {
      const customOptions = this.directivePopoverConfig();

      this._popover.popperOptions = (options: Partial<Options>): Partial<Options> => {
        // Default configuration
        options.onFirstUpdate = (state): void => {
          if (state.elements?.arrow) {
            state.elements.arrow.style.display = "none";
          }
        };

        // Merge with any custom options passed (ignore empty string)
        if (customOptions && typeof customOptions === "object") {
          // If custom options has modifiers, we might need to merge them carefully
          if (customOptions.modifiers && options.modifiers) {
            options.modifiers = [...options.modifiers, ...customOptions.modifiers];
          }
          // Copy other properties
          Object.assign(options, { ...customOptions, modifiers: options.modifiers });
        }

        return options;
      };
    });
  }
}
